<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class="background_color mb-5" >
              
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Assets<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/cmmsassets/index"> Manage Assets  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update Assets  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Update Customer </b></h6> -->
                <div class="container-fluid ">
                <div class="card ">
                <div class="card-body">


                    <form @submit.prevent="SaveCustomer()" >

<div class="row">
  <!-- <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Dealer / Broker </label>
           
            <select @change="loadreopt1()"   class="form-select font-size_def" aria-label="Default select example" disabled>
              <option selected>Dealer</option>
              <option >Broker</option>
            
            </select>
    </div>
  </div> -->
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Asset Name </label>
           
              <input  v-model="customer.asset_name"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Asset Code </label>
           <input  v-model="customer.asset_code"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Asset Description</label>
            <input  v-model="customer.asset_dis"  style="font-size: small;" class="form-control" required>
    </div>
  </div>

  <div class="col-md-3">
     <div class="form-group required">
             <label class="custom-label" style="font-size: small;">Department </label>
            
            <v-select class="font-size_def" label="label"    v-model="customer.idcustomer"  :options="departments" ></v-select>
             
     </div>
   </div>
  
</div>



                 

 





<div class="row">
  <div class="col-md-3">
     <div class="form-group required">
             <label class="custom-label" style="font-size: small;">Location </label>
            
            <v-select class="font-size_def" label="label"   v-model="customer.location"  :options="locations" ></v-select>
             
     </div>
   </div>
 
 <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">District </label>
            <input  v-model="customer.district"  style="font-size: small;" class="form-control" >
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Country</label>
            <input  v-model="customer.country"  style="font-size: small;" class="form-control" >
    </div>
  </div>

   <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Supplier </label>
               <v-select class="font-size_def" label="label"    v-model="customer.idsupplier"  :options="msuplliers" ></v-select>
    </div>
  </div>
</div>
<div class="row">
 <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Warranty End Date </label>
           <input type="date"  v-model="customer.wrty_end_date"  style="font-size: small;" class="form-control" >
    </div>
  </div>
 <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">File Upload</label>
                 <input 
  type="file" 
  ref="fileInput" 
  @change="handleFileUpload" 
  style="font-size: small;" 
  class="form-control"
/>
    </div>
  </div>

</div>




















   <div>
   

  
  </div>


 






    <h6 class="purchitem mb-2"><b>Operator Contact List</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        <thead class="background_color2">
          <tr>
           
                <th>   
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Contact Name</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Designation</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2">Email</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Mobile No</label>
                  </div>
                </th>
                
              
                <th></th>  
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in details" :key="detail.id">
                <input v-model="detail.id" type="hidden"  style="font-size: small;" class="form-control">
              <td><input v-model="detail.name"  style="font-size: small;" class="form-control" required></td>
              <td><input v-model="detail.designation" style="font-size: small;" class="form-control" ></td>
              <td><input v-model="detail.email"  style="font-size: small;" class="form-control" ></td>
              <td><input v-model="detail.tel" style="font-size: small;" class="form-control" required></td>
              
              
            </tr>
         
            
           



          
            
          </tbody>


        </table>
       
    </div>
    

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Update</button>
    </div>
    </div>



</form>

<br><br>


                </div>
                </div>
           
            </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSalespeople();
    this.loadData();
    this.loadDepart();
    // this.initMap();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            count: 0,
        total:0,
        selectedOption: null,
        'idcustomer':this.$route.query.id, // Store the selected option
     
      departments:[],
      msuplliers:[],
      locations:[],
      salespeoples:[

      ],
       map: null,
      marker: null,
      searchAddress: '',
        customer: {
        lat: null,
        lng: null,
        C_address_line1: ''
      },
      
        details:[],
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
    

          async loadData() {
       
     
      try {
        const { data} = await  axios.get('/ciinventory/loadupdate?id='+this.idcustomer,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.customer = data.item_list;
       
        
       
         this.details = data.item_det;
      } catch (error) {
        console.log(error.response);
      }
    },

      initMap(lat, lon) {
  // fallback values if lat/lon are not valid
  const fallbackLocation = { lat: 7.8731, lng: 80.7718 }; // Sri Lanka center

  // Parse and validate coordinates
  const latitude = parseFloat(lat);
  const longitude = parseFloat(lon);
  const validCoords = !isNaN(latitude) && !isNaN(longitude);

  const defaultLocation = validCoords
    ? { lat: latitude, lng: longitude }
    : fallbackLocation;

  this.map = new google.maps.Map(document.getElementById("map"), {
    center: defaultLocation,
    zoom: 13,
  });

  this.marker = new google.maps.Marker({
    position: defaultLocation,
    map: this.map,
    draggable: true,
  });

  this.map.addListener("click", (event) => {
    const clickedLat = event.latLng.lat();
    const clickedLng = event.latLng.lng();
    this.setMapLocation(clickedLat, clickedLng);
    this.reverseGeocode(clickedLat, clickedLng);
  });

  this.initAutocomplete();
},
     setMapLocation(lat, lng) {
      const position = { lat: parseFloat(lat), lng: parseFloat(lng) };
      // this.map.setCenter(position);
    //  this.map.setZoom(15);
      this.marker.setPosition(position);
      this.customer.lat = lat;
      this.customer.lng = lng;
    },

    reverseGeocode(lat, lng) {
      const geocoder = new google.maps.Geocoder();
      const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK" && results[0]) {
          this.searchAddress = results[0].formatted_address;
          this.customer.C_address_line1 = results[0].formatted_address;
        }
      });
    },

    initAutocomplete() {
      const autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete);
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.geometry || !place.geometry.location) return;

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        this.setMapLocation(lat, lng);
        this.customer.C_address_line1 = place.formatted_address;
      });
    },
          async loadSalespeople() {
       
     
      try {
        const { data} = await  axios.get('/msalespeople/salespeopleload',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.salespeoples = data.item_list;
        
        
      } catch (error) {
        console.log(error.response);
      }
    },


     async loadDepart() {
       
     
      try {
        const { data} = await  axios.get('/ciinventory/loaddepart',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.departments = data.deps;
         this.locations = data.locs;
          this.msuplliers = data.sups;
        
      } catch (error) {
        console.log(error.response);
      }
    },

       handleFileUpload(event) {
  this.file = event.target.files[0];
},

 async SaveCustomer() {
  try {
    let formData = new FormData();

    formData.append('idcustomer', this.idcustomer);
    formData.append('userid', this.userid);
    formData.append('customer', JSON.stringify(this.customer));
    formData.append('details', JSON.stringify(this.details));

    if (this.file) {
      formData.append('file_my', this.file);
    }

    const { data } = await axios.post(
      '/ciinventory/update',
      formData,
      {
        headers: {
          'Authorization': 'Bearer ' + this.access_token,
          'Content-Type': 'multipart/form-data',
        }
      }
    );

    console.log(data);

    if (data.status === 200) {
       this.$router.push('/cmmsassets/view?id='+this.idcustomer);
    }

  } catch (error) {
    console.log(error.response);
  }
},     

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    